import { useManageChatroomMembersMutation } from '@pba/react-chat-core';
import { Modal, message } from 'ui';
import {
  ChatGroupAddMembersFormContent,
  type ChatGroupAddMembersFormValues,
} from './chat-group-add-members-form-content';

type P = {
  chatroomId: string;
  isOpened: boolean;
  onCancel: () => void;
};

const ChatGroupAddMembersModal = ({ chatroomId, isOpened, onCancel }: P) => {
  const { isPending, mutate: manageChatroomMembers } = useManageChatroomMembersMutation();

  const onFinish = (values: ChatGroupAddMembersFormValues) => {
    const selectedUsers = values.users;

    if (!selectedUsers?.length) {
      message.error('You must select at least 1 member to add.');
      return;
    }

    manageChatroomMembers(
      {
        chatroomId,
        membersToAdd: selectedUsers.map((user) => ({
          _id: user.id,
          participant: {
            email: user.email,
            firstName: user.firstName,
            lastName: user.lastName,
          },
        })),
      },
      {
        onError() {
          message.error("Something went wrong. Member(s) couldn't be added.");
        },
        onSuccess() {
          message.success('Member(s) added successfully');
          onCancel();
        },
      },
    );
  };

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title="Add members" width="small">
      <Modal.HugContent>
        <ChatGroupAddMembersFormContent isPending={isPending} onCancel={onCancel} onFinish={onFinish} />
      </Modal.HugContent>
    </Modal>
  );
};

export default ChatGroupAddMembersModal;
